import { Component, OnInit, Inject } from '@angular/core';
import { Ae2UserModel, Ae2UserVaccineAddPayloadModel } from '@studios-smart/core/services/users';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Ae2DialogResponse } from '@studios-smart/core/classes/dialog-response';
import { Ae2HttpResponseMessagesService } from '@studios-smart/core/services/http-response-messages';
import { Ae2FeedbackFormat, Ae2FeedbackService } from '@studios-smart/core/services/feedback';
import { Ae2DateTime } from '@studios-smart/core/classes/datetime/datetime';
import { Ae2UserService } from '@studios-smart/core/services/users/users.service';
import { Store, select } from '@ngrx/store';
import { Ae2AuthSetSessionAction, Ae2AuthUpdateEffectAction } from '@studios-smart/core/stores/auth/auth-actions';
import { Ae2AlertDialogData } from '@studios-smart/core/services/dialog/dialog.model';
import { Ae2DialogService } from '@studios-smart/core/services/dialog/dialog.service';

@Component({
    selector: 'app-other-instructor',
    templateUrl: './other-instructor.component.html',
    styleUrls: ['./other-instructor.component.sass'],
    providers: [Ae2UserService]
})
export class OtherInstructorComponent implements OnInit {

    event: any;

    constructor(
        private mdDialogRef: MatDialogRef<OtherInstructorComponent>,
        @Inject(MAT_DIALOG_DATA) private mdDialogData: any,
    ) {

    }

    ngOnInit(): void {
        this.event = this.mdDialogData.event;
    }

    close(): void {
        this.mdDialogRef.close(new Ae2DialogResponse(false));
    }


}
